import classNames from 'classnames';
import React from 'react';
import CloakLoading from '../../../../../../ReactSharedScripts/components/CloakLoading';
import classes from '../../styles/index.module.scss';

export const ContentCloak = ({ className }) => {
	const componentClasses = classNames(classes.contentCloak, className);

	return <CloakLoading className={componentClasses} />;
};
